import React from 'react';

function TodoError() {
  return <p>Desespérate, hubo un error...</p>;
}

export { TodoError };
